import moment from 'moment'

export default (value, format = 'MMM Do YYYY') => {
  if (!value) {
    return ''
  }

  return moment(value).format(format)
}
